import { NumericFormat } from 'react-number-format';

export default function ReportRow(props) {
    const negativeStyle = {
        color: 'red !important'
    };

    const negativeClass = {
        className: 'negative-value'
    };

    if (props.isPercent) {
        return (<>
            <tr className="reportRow">
                <td className="reportMetric">{props.metric}</td>
                {props.financials.map((f) => {
                    const isNegative = f[props.name] < 0;
                    return (
                        <>
                            <td className={isNegative ? 'negative-value' : 'positive-value'}>
                                <NumericFormat
                                    value={Number(f[props.name]).toFixed(2)}
                                    thousandSeparator=","
                                    decimalScale={2}
                                    displayType='text'
                                    allowNegative={false}

                                    prefix={isNegative ? '(' : ''}
                                    suffix={isNegative ? ' %)' : ' %'}
                                />
                            </td>
                            <td className={isNegative ? 'negative-value' : 'positive-value'}>
                                <NumericFormat
                                    value={f[props.percentName]}
                                    thousandSeparator=","
                                    decimalScale={2}
                                    displayType='text'
                                    prefix={isNegative ? '(' : ''}
                                    suffix={isNegative ? ' %)' : ' %'}
                                />
                            </td>
                        </>
                    )
                })}
            </tr>
        </>)
    }
    else if (props.isText)
    {
        return (<>
            <tr className="reportRow">
                <td className="reportMetric">{props.metric}</td>
                {props.financials.map((f) => {
                    return (
                        <>
                            <td className="positive-value">
                                {
                                    props.decimalScale?
                                    Math.round(f[props.name],0)
                                    :
                                    f[props.name]
                                }
                            </td>

                            <td className="positive-value">
                                {props.percentName?f[props.percentName]:''}
                            </td>
                        </>
                    )
                })}
            </tr>
        </>)
    }
    else {
        return (<>
            <tr className="reportRow">
                <td className="reportMetric">{props.metric}</td>
                {props.financials.map((f) => {
                    const isNegative = f[props.name] < 0;
                    return (
                        <>
                            <td className={isNegative ? 'negative-value' : 'positive-value'}>
                                <NumericFormat
                                    value={f[props.name]}
                                    thousandSeparator=","
                                    decimalScale={props.decimalScale?props.decimalScale:0}
                                    displayType='text'
                                    allowNegative={false}
                                    prefix={isNegative ? '($' : '$'}
                                    suffix={isNegative ? ')' : ''}
                                />
                            </td>

                            <td className={isNegative ? 'negative-value' : 'positive-value'}>
                                <NumericFormat
                                    value={f[props.percentName]}
                                    thousandSeparator=","
                                    decimalScale={2}
                                    displayType='text'
                                    allowNegative={false}
                                    prefix={isNegative ? '(' : ''}
                                    suffix={isNegative ? ' %)' : ' %'}

                                />
                            </td>
                        </>
                    )
                })}
            </tr>

        </>);
    }
}